import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';

interface OrganisationType {
  id: number;
  name: string;
  slug: string;
}

interface Organisation {
  id: string;
  name: string;
  typeId?: number | null;
  type?: OrganisationType | null;
  allunitedSection?: string | null;
  [key: string]: any;
}

@Component({
  selector: 'app-organisation-dialog',
  templateUrl: './organisation-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FormsModule,
    MatDialogModule,
  ],
})
export class OrganisationDialogComponent implements OnInit {
  organizationTypes: OrganisationType[] = [];
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(
    public dialogRef: MatDialogRef<OrganisationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Partial<Organisation>,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.fetchOrganizationTypes();
  }

  fetchOrganizationTypes() {
    this.http.get<OrganisationType[]>(`${this.apiBaseUrl}/organization-types`)
      .subscribe({
        next: (types) => {
          this.organizationTypes = types;
        },
        error: (err) => {
          console.error('Failed to load organization types', err);
        }
      });
  }

  isAllUnitedType(): boolean {
    if (!this.data.typeId) return false;
    const selectedType = this.organizationTypes.find(t => t.id === this.data.typeId);
    return selectedType?.slug === 'allunited';
  }

  onSubmit() {
    if (!this.data.name) {
      return;
    }

    // Validate allunitedSection is required when type is allunited
    if (this.isAllUnitedType() && !this.data.allunitedSection) {
      return;
    }

    this.dialogRef.close(this.data);
  }
}
